import { Menu, Search } from 'lucide-react'
import { Link } from 'react-router-dom'

import { AccountMenu } from './AccountMenu'

interface HeaderProps {
  onMenuClick: () => void
  onSearch: () => void
}

/**
 * Small screens only: Shopify's black top bar (menu, platform mark, search, store menu). On desktop the sidebar
 * carries search and the store menu, so there is no header.
 */
export const Header = ({ onMenuClick, onSearch }: HeaderProps) => (
  <header className="flex h-[52px] items-center gap-1 bg-frame px-2 text-sidebar-foreground lg:hidden">
    <button
      type="button"
      onClick={onMenuClick}
      aria-label="Open menu"
      className="grid size-9 place-items-center rounded-md outline-none hover:bg-sidebar-hover focus-visible:ring-2 focus-visible:ring-sidebar-ring"
    >
      <Menu className="size-5" />
    </button>
    <Link to="/" aria-label="Home" className="rounded-md outline-none focus-visible:ring-2 focus-visible:ring-sidebar-ring">
      <img src="/favicon.png" alt="" className="size-7 rounded-md" />
    </Link>
    <div className="flex-1" />
    <button
      type="button"
      onClick={onSearch}
      aria-label="Search"
      className="grid size-9 place-items-center rounded-md outline-none hover:bg-sidebar-hover focus-visible:ring-2 focus-visible:ring-sidebar-ring"
    >
      <Search className="size-5" />
    </button>
    <AccountMenu compact />
  </header>
)
